import * as React from 'react'

function IconArrowPrev(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={62}
      height={62}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={62} height={62} rx={31} fill="#E84E25" />
      <path
        d="M43.55 42.704v-4.608l-19.727-8.208 19.728-8.16V17.12L18.447 27.776v4.272L43.55 42.704z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconArrowPrev
